export const doExchange = (doubleArrays) => {
    let len = doubleArrays.length;
    if(len == 1){
        let arr = doubleArrays[0];
        let temp = new Array(arr.length);
        let index = 0;
        for (let i = 0; i < arr.length; i++) {
            temp[index] = [arr[i]];
            index++;
        }
        return temp;
    }
    if (len == 2) {
        let arr1 = doubleArrays[0];
        let arr2 = doubleArrays[1];
        let len1 = doubleArrays[0].length;
        let len2 = doubleArrays[1].length;
        let newlen = len1 * len2;
        let temp = new Array(newlen);
        let index = 0;
        for (let i = 0; i < len1; i++) {
            for (let j = 0; j < len2; j++) {
                temp[index] = arr1[i] + "," + arr2[j];
                temp[index] = [arr1[i],arr2[j]];
                index++;
            }
        }
        return temp;
    }
    if (len == 3) {
        let arr1 = doubleArrays[0];
        let arr2 = doubleArrays[1];
        let arr3 = doubleArrays[2];
        let len1 = doubleArrays[0].length;
        let len2 = doubleArrays[1].length;
        let len3 = doubleArrays[2].length;
        let newlen = len1 * len2 * len3;
        let temp = new Array(newlen);
        let index = 0;
        for (let i = 0; i < len1; i++) {
            for (let j = 0; j < len2; j++) {
                for (let k =0;k < len3;k++){
                    temp[index] = [arr1[i],arr2[j],arr3[k]];
                    index++;
                }
            }
        }
        return temp;
    }
    
}